import NumberStepper from '../../NumberStepper';
import type { FieldRendererProps } from '../types';

export function NumberStepperField({ field, isDisabled, onChange }: FieldRendererProps) {
  return (
    <NumberStepper
      amount={Number(field.value || 0)}
      disabled={isDisabled}
      min={1}
      max={Number.MAX_VALUE}
      onChange={(event) => onChange(event.toString(), undefined, field.entityID.toString())}
      onRemove={() => onChange('0', undefined, field.entityID.toString())}
      stepSize={1}
    />
  );
}
